/**
 * The Skills page's route search vocabulary, kept out of the page module so the
 * two routes can register `validateSearch` without pulling the lazy Skills
 * bundle back into the entry chunk.
 */

export const SKILL_SEARCH_KEY = 'skill';

/** `skill` names the open skill as `custom:<id>` or `official:<id>`; nothing else survives. */
export function validateSkillsSearch(
  search: Record<string, unknown>,
): Record<string, string | string[]> {
  const result: Record<string, string | string[]> = {};
  const skill = search[SKILL_SEARCH_KEY];
  if (typeof skill === 'string' && /^(custom|official):[^\s]+$/.test(skill)) {
    result[SKILL_SEARCH_KEY] = skill;
  }
  return result;
}
